import React from "react";
import { Link } from "react-router-dom";

export function ComprendreRedirect() {
  return (
    <main className="max-w-2xl mx-auto py-10 space-y-4">
      <h1 className="text-2xl font-bold">La rubrique “Comprendre” a évolué</h1>
      <p>Retrouvez désormais ces contenus dans la rubrique <strong>Academy</strong>.</p>
      <Link to="/academy" className="text-blue-600 underline">
        Accéder à MixMind Academy
      </Link>
    </main>
  );
}

export function PratiquerRedirect() {
  return (
    <main className="max-w-2xl mx-auto py-10 space-y-4">
      <h1 className="text-2xl font-bold">La rubrique “Pratiquer” devient Play</h1>
      <p>Les mini-jeux et entraînements sont regroupés dans <strong>Play</strong>.</p>
      <Link to="/play" className="text-blue-600 underline">
        Ouvrir MixMind Play
      </Link>
    </main>
  );
}

export function ExplorerRedirect() {
  return (
    <main className="max-w-2xl mx-auto py-10 space-y-4">
      <h1 className="text-2xl font-bold">La rubrique “Explorer” est déplacée</h1>
      <p>Les illusions et prototypes sont accessibles via <strong>Play · Illusions</strong> ou <strong>Academy · Explorer</strong>.</p>
      <div className="flex gap-3 flex-wrap">
        <Link to="/play/illusions" className="text-blue-600 underline">
          Aller vers Play · Illusions
        </Link>
        <Link to="/academy/explorer" className="text-blue-600 underline">
          Aller vers Academy · Explorer
        </Link>
      </div>
    </main>
  );
}
